export const roleFrameworkChatUrl = (competencyLabel: string) => {
  const prompt = `/build-role-framework:platform:build-role-framework Help me build or extend our role and ${competencyLabel} framework. Interview me about our people's work, help define roles and expectations, and then help assign employees to roles. Preview each stage for my approval before saving.`;
  return `/ask-ai?${new URLSearchParams({ p: prompt, autosubmit: "1" })}`;
};
